//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import $api from 'teld-web-component'
    import {domain} from 'teld-web-component/lib/env'
    import {readCookie, eraseCookie} from 'teld-web-component/lib/method'
    import { GetCurrentUser, GetHlhtMerchant, logOut } from 'service'

    export default {
        name: "t-menu",
        data() {
            return {
                userInfo: null,
                HlhtMerchantInfo: null,
                // userInfo: {
                //     Name: '特来电'
                // },
                isMoblie: false,
                mobileHide: true,
                modalLogout: false,
                modal_ok_loading: false,
                isAuthentication: false,
                Avatar: require('../assets/img/common/noDataImg.png'),
                authState: '', // 0新增 1认证通过 2认证不通过 3未认证 4未登录
                modalAuthentication: false,
                onlineTest: false,

            }
        },
        mounted() {
            this.$Message.config({
                top: 70,
                duration: 2
            });
            this.init()
        },
        methods: {
            async init() {
                let isLogin = await $api.isLogin()
                if (isLogin) {
                    // let userInfo = sessionStorage.getItem('userInfo')
                    // if (userInfo) {
                    //     this.userInfo = JSON.parse(userInfo)
                    // } else {
                        this.GetCurrentUser()
                    // }
                    this.GetHlhtMerchant()
                }else{
                    this.authState = '4'
                }

            },

            GetCurrentUser(){
                let _this = this
                return GetCurrentUser(null, (res) => {
                    console.log(res)
                    if (res.state == "1") {
                        _this.userInfo = res.data;
                        sessionStorage.setItem('userInfo', JSON.stringify(_this.userInfo));
                    }
                })
            },

            GetHlhtMerchant(){
                let _this = this
                // let param = {
                //     Filter: JSON.stringify({
                //         UserId: ''
                //     })
                // }
                GetHlhtMerchant(null, (res) => {
                    if(res.state == '1'){
                        let data = res.data
                        if(data){
                            _this.HlhtMerchantInfo = data
                            _this.authState = data.State
                        }
                    }
                })
            },

            onNavbarToggle() {
                this.mobileHide = !this.mobileHide
            },

            async onModalOk() {
                this.modalLogout = false
                let _this = this;
                await $api.isLogin()
                let telda = readCookie('telda')
                let TELDSID = readCookie('TELDSID')
                if (telda) {
                    let data = {
                        logoutInfo: JSON.stringify({
                            "AccessToken": telda,
                            "ClientId": "",
                            "TELDSID": TELDSID
                        })
                    }
                    logOut(data, function (data) {
                        if (data.state == '1') {
                            _this.clearUserData()
                        } else {
                            _this.$Notice.error({
                                title: '注销失败',
                                desc: data.errmsg
                            })
                        }
                    })
                } else {
                    _this.clearUserData()
                }
            },

            clearUserData(){
                this.userInfo = null
                this.HlhtMerchantInfo = null
                this.authState = '4'
                this.clearIdentity()
                this.$router.replace({path: '/'})
            },

            onModalCannel() {
                this.modalLogout = false
            },
            onModalAuthCannel(){
                this.modalAuthentication = false
            },
            onModalAuthOk(){
                this.modalAuthentication = false
                window.location.href = `//user${domain}/newlogin?source=7&redirect_uri=${encodeURIComponent(window.location.origin)}/authentication`;
            },

            onDropClick(name) {
                let _this = this;
                switch (name) {
                    case 'goPensonalCenter':
                        _this.goPensonalCenter();
                        break;
                    case 'logout':
                        _this.onLogout();
                        break;
                }
            },

            goPensonalCenter() {
                window.open(`//www${domain}/PersonalCenter/PersonalCenter`)
            },

            goOnLineTest() {
                if (this.authState !== '1') {
                    this.onlineTest = true
                } else {
                    window.open(`//web${domain}/#/openms`)
                }
            },

            goAuthentication(){
                if (this.authState == '4') {
                    this.modalAuthentication = true
                } else {
                    this.$router.push({path: '/authentication'})
                }
            },

            goRegister() {
                window.location.href = `//user${domain}/newsignin?source=7&redirect_uri=${encodeURIComponent(window.location.href)}`;
            },

            goLogin() {
                this.clearIdentity()
                window.location.href = `//user${domain}/newlogin?source=7&redirect_uri=${encodeURIComponent(window.location.href)}`;
            },

            clearIdentity() {
                if (readCookie('teldc') != '1') {
                    eraseCookie("teldk")
                    eraseCookie("teldb")
                    eraseCookie("teldc")
                    eraseCookie("teldz")
                }
                eraseCookie("TELDSID");
                eraseCookie("telda");
            },

            onLogout() {
                this.modalLogout = true
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/tMenu.vue